import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punedarshancabservice() {



  const cardData = {
"keyword": "Pune Darshan Cab Service",

"headingDescription":
  "Shivai Travels offers reliable and comfortable Pune Darshan Cab Service for tourists, families, and business travelers who want to explore Pune city in a convenient and hassle-free way. Whether you are visiting for sightseeing, shopping, temple visits, historical tours, weekend trips, or local exploration, our cab service ensures a smooth and enjoyable city travel experience. With experienced drivers who know Pune routes and traffic conditions well, clean air-conditioned vehicles maintained for comfort, and transparent pricing with no hidden charges, we provide a dependable travel experience across Pune. Our fleet includes sedans, SUVs, Innova cars, and premium vehicles suitable for solo travelers, families, and groups. With flexible half-day and full-day packages, doorstep pickup, easy cab booking, and 24/7 customer support, Shivai Travels ensures a comfortable and well-planned Pune sightseeing experience.",

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description":
      "Shaniwar Wada is a historic fort palace in the heart of Pune known for its Maratha heritage, architectural grandeur, and historical significance. It is one of the most visited tourist attractions included in Pune Darshan Cab Service."
  },
  {
    "title": "Aga Khan Palace",
    "description":
      "Aga Khan Palace is a major historical landmark associated with Mahatma Gandhi and India’s freedom movement. It features beautiful architecture, peaceful gardens, and a museum showcasing important historical artifacts."
  },
  {
    "title": "Sinhagad Fort",
    "description":
      "Sinhagad Fort is a popular hill fort near Pune known for trekking, panoramic views, and Maratha history. It is a must-visit destination for adventure lovers and history enthusiasts."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description":
      "Dagdusheth Halwai Ganpati Temple is one of the most famous temples in Pune dedicated to Lord Ganesha. It attracts thousands of devotees daily and is a key spiritual stop in city tours."
  },
  {
    "title": "Parvati Hill Temple",
    "description":
      "Parvati Hill Temple is a peaceful hilltop temple offering panoramic views of Pune city. It is a spiritual and scenic destination ideal for sunrise and sunset visits."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description":
      "Raja Dinkar Kelkar Museum showcases a vast collection of historical artifacts, musical instruments, sculptures, and traditional Indian art, making it a cultural highlight of Pune."
  },
  {
    "title": "Osho Ashram (Osho International Meditation Resort)",
    "description":
      "Osho Ashram is a world-famous meditation center known for its peaceful environment, wellness programs, and spiritual activities attracting visitors from across the globe."
  },
  {
    "title": "Koregaon Park",
    "description":
      "Koregaon Park is a vibrant area in Pune known for cafes, restaurants, shopping spots, and nightlife, making it a popular stop during city sightseeing tours."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description":
      "Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva, located in the city center and known for its unique architecture and historical importance."
  },
  {
    "title": "Pune City Scenic Drive",
    "description":
      "The Pune Darshan route covers a mix of historical landmarks, spiritual places, cultural hubs, and modern attractions, offering a complete city experience with comfortable cab travel."
  }
],



services: [
  {
    name: "Pune Darshan Cab",
    description: "Pune Darshan cab service provides reliable transportation for passengers exploring the famous attractions and heritage sites of Pune. Comfortable vehicles with experienced drivers ensure smooth city travel for families, tourists, and local travelers. Pickup services are available from homes, hotels, railway stations, airport terminals, and offices across Pune. Vehicles include sedans, SUVs, Innova Crysta, and premium taxis suitable for different sightseeing requirements. Flexible booking options allow convenient half-day and full-day Pune Darshan travel reservations."
  },
  {
    name: "Pune City Darshan Taxi",
    description: "Pune city Darshan taxi service offers dependable transportation for sightseeing tours across Pune city with professional chauffeurs and comfortable vehicles. Vehicles provide spacious seating and smooth local travel suitable for tourism, heritage visits, and family outings. Professional drivers ensure punctual pickup and safe driving services throughout the city tour. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient city sightseeing taxi reservations."
  },
  {
    name: "Pune Sightseeing Cab",
    description: "Pune sightseeing cab service provides comfortable transportation for passengers visiting popular tourist attractions, temples, forts, museums, and cultural landmarks in Pune. Vehicles ensure reliable local travel with experienced chauffeurs offering safe and smooth city journeys. Pickup services are available from residential areas, offices, hotels, railway stations, and airports across Pune. Ideal for one-day sightseeing and tourism requirements. Flexible booking options allow convenient sightseeing cab reservations."
  },
  {
    name: "Pune Local Tour Cab",
    description: "Pune local tour cab service offers reliable transportation with comfortable vehicles and professional drivers for exploring Pune city and nearby attractions. Vehicles provide smooth city travel suitable for tourism, sightseeing, shopping trips, and family outings. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow easy local tour cab reservations."
  },
  {
    name: "Pune Darshan Taxi Service",
    description: "Pune Darshan taxi service provides dependable transportation solutions for passengers traveling across Pune for sightseeing and local tourism. Vehicles are suitable for city travel ensuring safe and smooth journeys for individuals, families, and group travelers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Ideal for tourism, heritage visits, and local sightseeing tours. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Pune Tourist Cab Service",
    description: "Pune tourist cab service provides transparent and reliable transportation for travelers visiting Pune's famous tourist attractions and heritage landmarks. Travelers can enjoy comfortable journeys with experienced drivers familiar with local sightseeing routes and destinations. Comfortable vehicles ensure smooth city travel with safe transportation services throughout the tour. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient tourist cab reservations."
  },
  {
    name: "Pune City Tour Cab",
    description: "Pune city tour cab service provides economical and comfortable transportation for travelers planning sightseeing tours across Pune city. Comfortable vehicles ensure smooth city travel suitable for tourism, shopping, and family outings. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient city tour cab reservations."
  },
  {
    name: "Pune Half Day Tour Cab",
    description: "Pune half day tour cab service offers convenient transportation for passengers planning short sightseeing trips across Pune city. Comfortable vehicles provide smooth local travel with experienced drivers ensuring safe and reliable transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Ideal for local sightseeing, shopping, and tourism visits. Flexible booking options allow convenient half-day cab reservations."
  },
  {
    name: "Pune Full Day Darshan Cab",
    description: "Pune full day Darshan cab service allows passengers to reserve comfortable transportation for exploring multiple attractions and tourist places across Pune throughout the day. Vehicles include sedans, SUVs, luxury cars, Innova Crysta, and premium taxis suitable for different passenger requirements. Professional drivers ensure safe driving and punctual pickup services throughout the city tour. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow full-day Darshan cab reservations."
  },
  {
    name: "Best Pune Darshan Cab",
    description: "Best Pune Darshan cab service provides affordable and premium transportation options for tourists exploring Pune city. Vehicles ensure reliable city travel suitable for sightseeing, heritage tours, temple visits, and family outings. Professional drivers ensure safe driving and timely pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Pune Darshan cab reservations."
  },
  {
    name: "Cheap Pune Darshan Taxi",
    description: "Cheap Pune Darshan taxi service offers economical transportation with comfortable vehicles and professional chauffeurs for local sightseeing tours. Vehicles provide comfortable seating and reliable city performance suitable for tourism, shopping trips, and family travel. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient low-cost taxi reservations."
  },
  {
    name: "SUV Pune City Tour Cab",
    description: "SUV Pune city tour cab service provides spacious transportation for families and groups traveling across Pune for sightseeing and tourism. SUV vehicles offer comfortable seating, luggage capacity, and smooth city performance suitable for family outings and local tours. Professional chauffeurs ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient SUV tour cab reservations."
  },
  {
    name: "Innova Pune Darshan Cab",
    description: "Innova Pune Darshan cab service provides premium SUV transportation for passengers seeking comfortable and reliable city sightseeing travel. Innova vehicles offer spacious seating, smooth ride quality, and luggage space suitable for tourism, sightseeing, and family trips. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Innova cab reservations."
  },
  {
    name: "Sedan Pune Sightseeing Cab",
    description: "Sedan Pune sightseeing cab service offers economical and comfortable transportation for solo travelers, couples, and small families exploring Pune city. Sedan vehicles provide smooth city travel with comfortable seating and luggage space suitable for local sightseeing journeys. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient sedan cab reservations."
  },
  {
    name: "Pune Heritage Sightseeing Cab",
    description: "Pune heritage sightseeing cab service offers dependable transportation for passengers exploring Pune’s historical landmarks, forts, museums, temples, and cultural attractions. Comfortable vehicles ensure smooth city travel suitable for tourism, educational tours, and family vacations. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient heritage sightseeing cab reservations."
  }
],

tableData: [
  ["Pune Darshan Cab", "Pune City Darshan Taxi"],
  ["Pune Sightseeing Cab", "Pune Local Tour Cab"],
  ["Pune Darshan Taxi Service", "Pune Tourist Cab Service"],
  ["Pune City Tour Cab", "Pune Half Day Tour Cab"],
  ["Pune Full Day Darshan Cab", "Best Pune Darshan Cab"],
  ["Cheap Pune Darshan Taxi", "SUV Pune City Tour Cab"],
  ["Innova Pune Darshan Cab", "Sedan Pune Sightseeing Cab"],
  ["Pune Heritage Sightseeing Cab", "Pune Darshan Cab"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable Pune Darshan Cab Service",
        WhyChoosedescription: "Shivai Travels provides reliable Pune Darshan cab service with professional drivers, comfortable vehicles, and punctual pickup for smooth and convenient city sightseeing tours."
      },
      {
        WhyChooseheading: "Affordable Pune Sightseeing Taxi Fare",
        WhyChoosedescription: "Shivai Travels offers affordable Pune Darshan cab pricing with transparent fare details and no hidden charges. Customers receive complete sightseeing package information before booking confirmation."
      },
      {
        WhyChooseheading: "24/7 Pune Darshan Cab Availability",
        WhyChoosedescription: "Our Pune Darshan cab service operates 24 hours a day for city tours, family outings, tourist visits, business travelers, and customized sightseeing requirements."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC Cabs",
        WhyChoosedescription: "All taxis provided by Shivai Travels are fully air-conditioned, sanitized, and regularly maintained to provide comfortable travel experiences for Pune city sightseeing."
      },
      {
        WhyChooseheading: "Customized Pune Darshan Tour Packages",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including half-day Pune Darshan tours, full-day sightseeing packages, temple visits, historical tours, and customized city travel plans."
      },
      {
        WhyChooseheading: "Wide Range of Cab Vehicle Choices",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for couples, families, tourists, and group sightseeing tours."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, hotels, Pune Airport, railway stations, and all major Pune locations including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Pune City Routes",
        WhyChoosedescription: "Our experienced drivers are familiar with all major Pune sightseeing destinations and ensure smooth travel, proper route planning, and timely visits throughout the city tour."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune Darshan cab service?", answer: "Pune Darshan cab service provides comfortable taxi transportation for visiting famous tourist attractions, temples, forts, and historical places in Pune." },
    { question: "Is Pune Darshan cab service available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Pune Darshan cab service." },
    { question: "Which vehicles are available for Pune Darshan tours?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers." },
    { question: "Can I book a full-day Pune Darshan cab package?", answer: "Yes, customers can book half-day as well as full-day Pune Darshan taxi packages." },
    { question: "Which Pune tourist places are covered in the tour?", answer: "Shivai Travels covers popular destinations like Shaniwar Wada, Dagdusheth Ganpati, Sinhagad Fort, Saras Baug, Aga Khan Palace, and other tourist attractions." },
    { question: "Are all Pune Darshan taxis air-conditioned?", answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable sightseeing travel." },
    { question: "Can I book Pune Darshan cab service online?", answer: "Yes, customers can easily book Pune Darshan cab service online or through phone booking." },
    { question: "Do you provide cabs for family and group sightseeing tours?", answer: "Yes, Shivai Travels provides comfortable vehicles suitable for family tours and group travel." },
    { question: "Are Pune Darshan cab fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Pune Darshan cab service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, and peak tourist seasons." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Nikhil Kulkarni",
      feedback:
        "Booked Pune Darshan cab service with Shivai Travels. Comfortable vehicle, smooth sightseeing experience, and excellent driver guidance.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Sneha Patil",
      feedback:
        "Excellent Pune Darshan taxi service. Affordable pricing, clean cab, and wonderful city tour experience.",
      rating: 5
    }
  ];


















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Darshan Cab Service",
  "image": "https://shivaitravels.com/assets/images/pune-darshan-cab.jpg",
  "description": "Book Pune Darshan cab service for comfortable city sightseeing and local tour travel. Shivai Travels offers half-day and full-day Pune city tour packages with sedan, SUV, Innova, and luxury cab options available 24x7 for tourist places, heritage spots, and temple visits.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹9/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-darshan-cab"
  }
};





  return (
    <div>
<Helmet>
  <title>Pune Darshan Cab Service | City Tour Taxi Booking | +91 9689815477</title>

  <meta
    name="description"
    content="Book Pune Darshan cab service for city sightseeing and local tours. Affordable half-day and full-day packages with sedan, SUV, Innova, and luxury cabs available 24x7 for Pune tourist places, heritage spots, and temple visits."
  />

  <meta
    name="keywords"
    content="pune darshan cab, pune city darshan taxi, pune sightseeing cab, pune local tour cab, pune darshan taxi service, pune tourist cab service, pune city tour cab, pune half day tour cab, pune full day darshan cab, best pune darshan cab, cheap pune darshan taxi, suv pune city tour cab, innova pune darshan cab, sedan pune sightseeing cab, pune heritage sightseeing cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/63.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punedarshancabservice;